import {
    Handle,
    Position,
    NodeProps
} from "reactflow";
import styles from "./workflow-visualization-service-node.less";

type WorkflowVisualizationServiceNodeProps = NodeProps<{
    label: string;
    description: string;
    apiKey: string;
    isPrimary: boolean;
}>;

export const WorkflowVisualizationServiceNode = (props: WorkflowVisualizationServiceNodeProps) => {

    return (
        <div className={styles.nodeContainer}>
            {props.data.isPrimary && (
                <div className={styles.primaryIndicator}>P</div>
            )}
            <div className={styles.workflowVisualizationServiceNode}>
                <Handle type="target" position={Position.Top} />
                <div className={styles.nodeHeader}>{props.data.label}</div>
                {props.data.description && props.data.label !== props.data.description && (
                    <div className={styles.nodeBody}>
                        {props.data.description}
                    </div>
                )}
                <Handle type="source" position={Position.Bottom} />
            </div>
        </div>
    );
};